module.exports = __webpack_public_path__ + "img/north.be5030ca.webp";